import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { connect } from "react-redux";

import MARVEL from "./common/utils/MarvelUrls";

import HomePage from "./common/components/HomePage";
import PrivateRoute from "./common/components/PrivateRoute/PrivateRoute";
import MarvelLoginPage from "./common/components/MarvelLoginPage/MarvelLoginPage";
import LogoutPage from "./common/components/LogoutPage/LogoutPage";
import VeritasHomePage from "./veritas/shared/VeritasHomePage";
import KYCServiceDetailPage from "./veritas/data-services/components/kyc-services/KYCServiceDetailPage";
import KYCServicesListPage from "./veritas/data-services/components/kyc-services/KYCServicesListPage";
import KYBServicesListPage from "./veritas/data-services/components/kyb-services/KYBServicesListPage";
import KYBServiceDetailPage from "./veritas/data-services/components/kyb-services/KYBServiceDetailPage";
import DataSourceDetailPage from "./veritas/data-sources/components/DataSourceDetailPage";
import DataProvidersListPage from "./veritas/data-providers/components/DataProvidersListPage";
import DataProviderDetailPage from "./veritas/data-providers/components/DataProviderDetailPage";
import BillingGroupsListPage from "./veritas/billing-groups/components/BillingGroupsListPage";
import CountryCoverageListPage from "./veritas/country-coverage/components/CountryCoverageListPage";
import SupportHomePage from "./support/shared/SupportHomePage";
import TxDebugLogsPage from "./support/tx-debug-logs/TxDebugLogsPage";
import TestCacheListPage from "./support/testcache/TestCacheListPage";
import KYBTestCacheListPage from "./support/testcache/KYBTestCacheListPage";
import BillingHomePage from "./billing/shared/BillingHomePage";
import BillingOrganizationsListPage from "./billing/organizations/components/BillingOrganizationsListPage";
import BillingOrganizationsDetailPage from "./billing/organizations/components/BillingOrganizationsDetailPage";
import CountryDetailPage from "./veritas/country-coverage/components/CountryDetailPage";
import BillingGroupDetailPage from "./veritas/billing-groups/components/BillingGroupDetailPage";
import PricingTablesListPageV2 from "./billing/pricing-tables/components/PricingTablesListPageV2";
import PricingDetailPage from "./billing/pricing-tables/components/PricingDetailPage";
import ManualEntryRecordsListPage from "./billing/manual-entry-billing-records/components/ManualEntryRecordsListPage";
import BillingReportPage from "./billing/billing-reports/components/BillingReportPage";

function Router(props) {
    const { authorized, isAdmin, isSupervisor, isTxDebugAdmin, isDPAdmin, isDPEditor, isBillingAdmin } = props;

    return (
        <Routes>

            <Route index path={MARVEL.HOME} element={
                <PrivateRoute authorized={authorized}>
                    <HomePage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.home} element={
                <PrivateRoute authorized={authorized}>
                    <VeritasHomePage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.kyc} element={
                <PrivateRoute authorized={authorized}>
                    <KYCServicesListPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.kyc_detail} element={
                <PrivateRoute authorized={authorized}>
                    <KYCServiceDetailPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.kyb} element={
                <PrivateRoute authorized={authorized}>
                    <KYBServicesListPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.kyb_detail} element={
                <PrivateRoute authorized={authorized}>
                    <KYBServiceDetailPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.data_providers} element={
                <PrivateRoute authorized={authorized}>
                    <DataProvidersListPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.dp_detail} element={
                <PrivateRoute authorized={authorized}>
                    <DataProviderDetailPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.data_source_detail} element={
                <PrivateRoute authorized={authorized}>
                    <DataSourceDetailPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.kyb_source_detail} element={
                <PrivateRoute authorized={authorized}>
                    <DataSourceDetailPage />
                </PrivateRoute>
            } />


            <Route index path={MARVEL.VERITAS.billing_groups} element={
                <PrivateRoute authorized={authorized && (isAdmin || isSupervisor || isDPAdmin || isDPEditor)}>
                    <BillingGroupsListPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.billing_group_detail} element={
                <PrivateRoute authorized={authorized && (isAdmin || isSupervisor || isDPAdmin || isDPEditor)}>
                    <BillingGroupDetailPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.country_coverage} element={
                <PrivateRoute authorized={authorized}>
                    <CountryCoverageListPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.VERITAS.country_detail} element={
                <PrivateRoute authorized={authorized}>
                    <CountryDetailPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.SUPPORT.home} element={
                <PrivateRoute authorized={authorized}>
                    <SupportHomePage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.SUPPORT.tx_debug} element={
                <PrivateRoute authorized={authorized && isTxDebugAdmin}>
                    <TxDebugLogsPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.SUPPORT.testcache} element={
                <PrivateRoute authorized={authorized}>
                    <TestCacheListPage />
                </PrivateRoute>
            } />

            {/* Redirect old URL to new KYC testcache URL */}
            <Route path="/support/testcache" element={<Navigate to="/support/kyc-testcache" replace />} />

            <Route index path={MARVEL.SUPPORT.kyb_testcache} element={
                <PrivateRoute authorized={authorized}>
                    <KYBTestCacheListPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.BILLING.home} element={
                <PrivateRoute authorized={authorized}>
                    <BillingHomePage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.BILLING.organizations} element={
                <PrivateRoute authorized={authorized}>
                    <BillingOrganizationsListPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.BILLING.manual_entry_records} element={
                <PrivateRoute authorized={authorized}>
                    <ManualEntryRecordsListPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.BILLING.billing_reports} element={
                <PrivateRoute authorized={authorized && isBillingAdmin}>
                    <BillingReportPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.BILLING.organization_detail} element={
                <PrivateRoute authorized={authorized}>
                    <BillingOrganizationsDetailPage />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.BILLING.pricing_tables_v2} element={
                <PrivateRoute authorized={authorized}>
                    <PricingTablesListPageV2 />
                </PrivateRoute>
            } />

            <Route index path={MARVEL.BILLING.pricing_tables_details_v2} element={
                <PrivateRoute authorized={authorized}>
                    <PricingDetailPage />
                </PrivateRoute>
            } />

            <Route path="/login" element={<MarvelLoginPage />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="*" element={<Navigate to="/home" />} />

        </Routes>
    );
}

const mapStateToProps = (state) => ({
    authorized: state.marvel.user.authorized,
    isAdmin: state.marvel.user.access.accessLevel.isAdmin,
    isSupervisor: state.marvel.user.access.accessLevel.isSupervisor,
    isTxDebugAdmin: state.marvel.user.access.accessLevel.isTxDebugAdmin,
    isDPAdmin: state.marvel.user.access.accessLevel.isDPAdmin,
    isDPEditor: state.marvel.user.access.accessLevel.isDPEditor,
    isBillingAdmin: state.marvel.user.access.accessLevel.isBillingAdmin,
});

export default connect(
    mapStateToProps,
)(Router);
